module.exports = __webpack_public_path__ + "img/kp-zzsjt.a7e532a1.png";